<div class="wrap-box">
  <div class="left-box m-t-sm">
    <!-- <nz-breadcrumb [nzAutoGenerate]="true"></nz-breadcrumb> -->
    <nz-breadcrumb >
      <nz-breadcrumb-item *ngFor="let item of currMenu;let i = index ">
        <a [routerLink]="[item.path]" [class]="{'routerLink-disable':i!==currMenu.length-1,'routerLink-enable':i==currMenu.length-1}">{{item.name}}</a>
      </nz-breadcrumb-item>
    </nz-breadcrumb>
    
  </div>

  <div class="right-box">
    <!-- <div class="help-view" routerLink="/help">
      <img src="assets/images/help.png" />
      <span>帮助中心</span>
    </div> -->
    <div class="line-view"></div> 
    <div class="user-view" (click)="showPopup=true">
      <img src="assets/images/default-face.png" />
      <span>{{currentUser.userName}}</span>
    </div>
    <!-- <div class="tenantInfo m-r-md" *ngIf="currentUser">
      <nz-avatar class="m-r-xs" nzSize="small" nzIcon="user" [nzSrc]="currentUser.avatar"></nz-avatar>
      {{currentUser.userName}}
    </div>

    <a *ngIf="loginType === 'tenant'" class="m-r-sm" (click)="tenantSelector.showTenantListModal()">
      <i nz-icon nzType="swap" nzTheme="outline"></i>切换公司
    </a>
    <a class="m-r-md" (click)="logout()">
      <i nz-icon nzType="logout" nzTheme="outline" ></i>登出
    </a> -->
  </div>
  <div *ngIf="showPopup" style="position: fixed;width: 100vw;height: 100vh;top: 0;left: 0;" (click)="showPopup = false">
    <div class="user-popup-view">
      <div *ngIf="loginType === 'tenant'" class="popup-item" (click)="tenantSelector.showTenantListModal()">
        <div class="popup-row">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14"
            viewBox="0 0 14 14">
            <defs>
              <style>
                .a1,
                .b1 {
                  fill: rgba(0, 0, 0, 0.85);
                }

                .b1 {
                  opacity: 0;
                }

                .c1 {
                  clip-path: url(#a1);
                }
              </style>
              <clipPath id="a1">
                <path class="a1"
                  d="M13.248-6.75H2.375a.125.125,0,0,0-.125.125v.938a.125.125,0,0,0,.125.125h9.456L9.577-2.7a.126.126,0,0,0,.1.2h1.133a.25.25,0,0,0,.2-.1l2.637-3.345a.5.5,0,0,0-.394-.809Zm.377-3.687H4.169L6.423-13.3a.126.126,0,0,0-.1-.2H5.192a.25.25,0,0,0-.2.1L2.358-10.059a.5.5,0,0,0,.392.809H13.625a.125.125,0,0,0,.125-.125v-.937A.125.125,0,0,0,13.625-10.437Z" />
              </clipPath>
            </defs>
            <g transform="translate(-1696 -132)">
              <rect class="b1" width="14" height="14" transform="translate(1696 132)" />
              <g transform="translate(1695 147)">
                <g class="c1">
                  <path class="a1" d="M1.1-14.5H14.9v13H1.1Z" />
                </g>
              </g>
            </g>
          </svg>
          <span>切换公司</span>
        </div>
        <div class="popup-name">
          {{currentUser.tenantName}}
        </div>
      </div>

      <div class="popup-item" (click)="updatePassword()">
        <div class="popup-row">
          <i nz-icon [nzType]="'setting'" class="marginPassword"></i>
          <span>密码修改</span>
        </div>
      </div>

      <div class="popup-item" (click)="logout()">
        <div class="popup-row">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14"
            viewBox="0 0 14 14">
            <defs>
              <style>
                .a,
                .b {
                  fill: rgba(0, 0, 0, 0.85);
                }

                .b {
                  opacity: 0;
                }

                .c {
                  clip-path: url(#a2);
                }
              </style>
              <clipPath id="a2">
                <path class="a"
                  d="M13.563-4.562h-1.1a.246.246,0,0,0-.192.091,5.056,5.056,0,0,1-.35.383A5.529,5.529,0,0,1,10.161-2.9a5.512,5.512,0,0,1-2.155.434A5.512,5.512,0,0,1,5.852-2.9,5.529,5.529,0,0,1,4.091-4.089,5.52,5.52,0,0,1,2.9-5.847,5.477,5.477,0,0,1,2.469-8,5.5,5.5,0,0,1,2.9-10.153a5.5,5.5,0,0,1,1.187-1.758A5.529,5.529,0,0,1,5.852-13.1a5.512,5.512,0,0,1,2.155-.434,5.485,5.485,0,0,1,2.155.434,5.529,5.529,0,0,1,1.761,1.186c.123.123.239.252.35.383a.248.248,0,0,0,.192.091h1.1a.124.124,0,0,0,.1-.192,6.722,6.722,0,0,0-5.678-3.089A6.711,6.711,0,0,0,1.281-7.931a6.723,6.723,0,0,0,6.725,6.65A6.723,6.723,0,0,0,13.667-4.37.125.125,0,0,0,13.563-4.562ZM14.952-8.1l-2.217-1.75a.125.125,0,0,0-.2.1v1.188H7.625a.125.125,0,0,0-.125.125v.875a.125.125,0,0,0,.125.125h4.906V-6.25a.125.125,0,0,0,.2.1L14.952-7.9a.125.125,0,0,0,0-.2Z" />
              </clipPath>
            </defs>
            <g transform="translate(-1696 -159)">
              <rect class="b" width="14" height="14" transform="translate(1696 159)" />
              <g transform="translate(1694.869 174.019)">
                <g class="c">
                  <path class="a" d="M.244-15.725H16V-.281H.244Z" />
                </g>
              </g>
            </g>
          </svg>
          <span>退出登录</span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showPassword" style="position: fixed;width: 100vw;height: 100vh;top: 0;left: 0;">
    <div class="user-popup-view login-view">
      <form class="homeloginForm" nz-form [formGroup]="tenantLoginForm">
        <nz-form-item *ngIf="loginType === 'tenant'" >
          <nz-form-control nzHasFeedback nzErrorTip="必填字段">
            <div class="input-view">
              <input disabled placeholder="{{'请输入手机号' | translate}}" formControlName="mobile" [(ngModel)]="tenantUser.mobile">
            </div>
          </nz-form-control>
        </nz-form-item>
        <div style="display: flex;justify-content: space-between;" *ngIf="loginType === 'tenant'">
          <nz-form-item>
            <nz-form-control nzHasFeedback nzErrorTip="必填字段">
              <div style="display: flex;align-items: flex-start;">
                <div class="input-view" style="width: 206px;">
                  <input placeholder="{{'请输入验证码' | translate}}" formControlName="smsCode" required (keyup.enter)="tenantLogin()"
                    [(ngModel)]="tenantUser.smsCode">
                </div>
              </div>
            </nz-form-control>
          </nz-form-item>
          <button class="m-r-sm" [disabled]="isSmsCodeSent" nz-button nzType="primary" nzSize="default"
                  nzShape="round" (click)="sendSmsCode()" style="width: 102px;height: 40px;font-size: 14px;">
                  <span *ngIf="!isSmsCodeSent">获取验证码</span>
                  <span *ngIf="isSmsCodeSent">{{countDownNum}}秒后重试</span>
                </button>
        </div>
        <nz-alert *ngIf="hintMessage" nzType="warning" [nzMessage]="hintMessage"></nz-alert>
        <nz-form-item *ngIf="loginType === 'admin'">
          <nz-form-control nzHasFeedback nzErrorTip="必填字段">
            <nz-form-label [nzSpan]="8" nzFor="oldPassword" nzRequired>{{'原密码' | translate}}</nz-form-label>
            <div class="input-view">
              <input placeholder="{{'请输入原密码' | translate}}" formControlName="oldPassword" [(ngModel)]="tenantUser.oldPassword" type="password">
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control nzHasFeedback nzErrorTip="必填字段">
            <nz-form-label *ngIf="loginType === 'admin'" [nzSpan]="8" nzFor="password" nzRequired>{{'新密码' | translate}}</nz-form-label>
            <div class="input-view">
              <input placeholder="{{'请输入新密码' | translate}}" formControlName="password" [(ngModel)]="tenantUser.password" type="password">
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control nzHasFeedback nzErrorTip="必填字段">
            <nz-form-label *ngIf="loginType === 'admin'" [nzSpan]="8" nzFor="confirmPassword" nzRequired>{{'新密码' | translate}}</nz-form-label>
            <div class="input-view">
              <input placeholder="{{'请再次输入新密码' | translate}}" formControlName="confirmPassword" [(ngModel)]="tenantUser.confirmPassword" type="password">
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-alert *ngIf="error" nzType="error" [nzMessage]="error"></nz-alert>
      </form>
      <div style="display:flex;justify-content:flex-end;">
        <button class="m-r-sm" nz-button nzType="primary" (click)="tenantLogin()">确认</button>
        <button nz-button (click)="cancel()">取消</button>
      </div>
    </div>
  </div>

</div>

<ng-container *ngIf="loginType === 'tenant'">
  <app-tenant-selector #tenantSelector></app-tenant-selector>
</ng-container>